module.exports = __webpack_public_path__ + "img/IMG-20200519-WA0019.ffc0b240.jpg";